import { orbCore } from 'services/Orb/Service'
import { parseActivityCategoryList, filterActivityCategoryList } from './Parser'

export const ActivityCategoryService = {
  list: () =>
    orbCore.categoryDomain.list()
      .then(parseActivityCategoryList)
      .then(filterActivityCategoryList)
}
